import {
  SAVE_SPOOL_FIT_UP,
  SAVE_SPOOL_FIT_UP_SUCCESS,
  SAVE_SPOOL_FIT_UP_FAILURE,
  SAVE_SPOOL_PREHEAT,
  SAVE_SPOOL_PREHEAT_SUCCESS,
  SAVE_SPOOL_PREHEAT_FAILURE,
  SAVE_SPOOL_WELDING,
  SAVE_SPOOL_WELDING_SUCCESS,
  SAVE_SPOOL_WELDING_FAILURE,
  SAVE_SPOOL_VT,
  SAVE_SPOOL_VT_SUCCESS,
  SAVE_SPOOL_VT_FAILURE,
  SAVE_SPOOL_NDT,
  SAVE_SPOOL_NDT_SUCCESS,
  SAVE_SPOOL_NDT_FAILURE,
  SAVE_SPOOL_COATING,
  SAVE_SPOOL_COATING_SUCCESS,
  SAVE_SPOOL_COATING_FAILURE,
  SAVE_SPOOL_ACCEPT,
  SAVE_SPOOL_ACCEPT_SUCCESS,
  SAVE_SPOOL_ACCEPT_FAILURE,
  CLEAR_SPOOL_TRACKER_SAVE_ERROR,
  FETCH_ALL_SPOOLS,
  FETCH_ALL_SPOOLS_SUCCESS,
  FETCH_ALL_SPOOLS_FAILURE,
  REGISTER_SPOOL_NCR,
  REGISTER_SPOOL_NCR_SUCCESS,
  REGISTER_SPOOL_NCR_FAILURE,
  FETCH_SPOOL_NCR_LIST,
  FETCH_SPOOL_NCR_LIST_SUCCESS,
  FETCH_SPOOL_NCR_LIST_FAILURE,
  FETCH_PROJECT_SPOOL_DASHBOARD,
  FETCH_PROJECT_SPOOL_DASHBOARD_SUCCESS,
  FETCH_PROJECT_SPOOL_DASHBOARD_FAILURE,
} from './types';

export const saveSpoolFitUp = (payload) => ({ type: SAVE_SPOOL_FIT_UP, payload });
export const saveSpoolFitUpSuccess = (payload) => ({ type: SAVE_SPOOL_FIT_UP_SUCCESS, payload });
export const saveSpoolFitUpFailure = (error) => ({ type: SAVE_SPOOL_FIT_UP_FAILURE, error });

export const saveSpoolPreheat = (payload) => ({ type: SAVE_SPOOL_PREHEAT, payload });
export const saveSpoolPreheatSuccess = (payload) => ({ type: SAVE_SPOOL_PREHEAT_SUCCESS, payload });
export const saveSpoolPreheatFailure = (error) => ({ type: SAVE_SPOOL_PREHEAT_FAILURE, error });

export const saveSpoolWelding = (payload) => ({ type: SAVE_SPOOL_WELDING, payload });
export const saveSpoolWeldingSuccess = (payload) => ({ type: SAVE_SPOOL_WELDING_SUCCESS, payload });
export const saveSpoolWeldingFailure = (error) => ({ type: SAVE_SPOOL_WELDING_FAILURE, error });

export const saveSpoolVt = (payload) => ({ type: SAVE_SPOOL_VT, payload });
export const saveSpoolVtSuccess = (payload) => ({ type: SAVE_SPOOL_VT_SUCCESS, payload });
export const saveSpoolVtFailure = (error) => ({ type: SAVE_SPOOL_VT_FAILURE, error });

export const saveSpoolNdt = (payload) => ({ type: SAVE_SPOOL_NDT, payload });
export const saveSpoolNdtSuccess = (payload) => ({ type: SAVE_SPOOL_NDT_SUCCESS, payload });
export const saveSpoolNdtFailure = (error) => ({ type: SAVE_SPOOL_NDT_FAILURE, error });

export const saveSpoolCoating = (payload) => ({ type: SAVE_SPOOL_COATING, payload });
export const saveSpoolCoatingSuccess = (payload) => ({ type: SAVE_SPOOL_COATING_SUCCESS, payload });
export const saveSpoolCoatingFailure = (error) => ({ type: SAVE_SPOOL_COATING_FAILURE, error });

export const saveSpoolAccept = (payload) => ({ type: SAVE_SPOOL_ACCEPT, payload });
export const saveSpoolAcceptSuccess = (payload) => ({ type: SAVE_SPOOL_ACCEPT_SUCCESS, payload });
export const saveSpoolAcceptFailure = (error) => ({ type: SAVE_SPOOL_ACCEPT_FAILURE, error });

export const clearSpoolTrackerSaveError = () => ({ type: CLEAR_SPOOL_TRACKER_SAVE_ERROR });

/** @param {{ projectId: string|number, pipeId: string|number }} payload */
export const fetchAllSpools = (payload) => ({ type: FETCH_ALL_SPOOLS, payload });
export const fetchAllSpoolsSuccess = (payload) => ({ type: FETCH_ALL_SPOOLS_SUCCESS, payload });
export const fetchAllSpoolsFailure = (error) => ({ type: FETCH_ALL_SPOOLS_FAILURE, error });

export const registerSpoolNcr = (payload) => ({ type: REGISTER_SPOOL_NCR, payload });
export const registerSpoolNcrSuccess = (payload) => ({ type: REGISTER_SPOOL_NCR_SUCCESS, payload });
export const registerSpoolNcrFailure = (error) => ({ type: REGISTER_SPOOL_NCR_FAILURE, error });

/** @param {{ projectId?: string|number|null, pipeId?: string|number|null, spoolId?: number }} payload */
export const fetchSpoolNcrList = (payload) => ({ type: FETCH_SPOOL_NCR_LIST, payload: payload || {} });
export const fetchSpoolNcrListSuccess = (payload) => ({ type: FETCH_SPOOL_NCR_LIST_SUCCESS, payload });
export const fetchSpoolNcrListFailure = (error) => ({ type: FETCH_SPOOL_NCR_LIST_FAILURE, error });

/** @param {{ projectId: string|number, pipeId?: string|number|null }} payload */
export const fetchProjectSpoolDashboard = (payload) => ({
  type: FETCH_PROJECT_SPOOL_DASHBOARD,
  payload: payload || {},
});
export const fetchProjectSpoolDashboardSuccess = (payload) => ({
  type: FETCH_PROJECT_SPOOL_DASHBOARD_SUCCESS,
  payload,
});
export const fetchProjectSpoolDashboardFailure = (error) => ({
  type: FETCH_PROJECT_SPOOL_DASHBOARD_FAILURE,
  error,
});
